import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {triggerNextDealTransition as next} from 'flows/deal/status';

import DealStatus from './components/DealStatus';
import DealFinalizingConfirmation from './components/DealFinalizingConfirmation';
import DealFinalizedConfirmation from './components/DealFinalizedConfirmation';
import DealClosedConfirmation from './components/DealClosedConfirmation';

export const LeadDealStatus = ({deal, next}) => (
  <div>
    <DealStatus deal={deal} next={() => next({deal})} data-test="deal_status" />
    <DealFinalizingConfirmation deal={deal} />
    <DealFinalizedConfirmation deal={deal} />
    <DealClosedConfirmation deal={deal} />
  </div>
)

LeadDealStatus.propTypes = {
  deal: PropTypes.object.isRequired,
  next: PropTypes.func.isRequired,
};

export default connect(null, {next})(LeadDealStatus);



// WEBPACK FOOTER //
// ./web/flows/deal/status_transitions/index.js